import { FC } from "react";
import { Styled } from "./layout";

export const TextSearchIcon: FC<Styled> = ({ className }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="CurrentColor"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M3 8C3.55 8 4 7.55 4 7V6C4 4.9 4.9 4 6 4H7C7.55 4 8 3.55 8 3C8 2.45 7.55 2 7 2H6C3.79 2 2 3.79 2 6V7C2 7.55 2.45 8 3 8Z" />
    <path d="M7 16H6C4.9 16 4 15.1 4 14V13C4 12.45 3.55 12 3 12C2.45 12 2 12.45 2 13V14C2 16.21 3.79 18 6 18H7C7.55 18 8 17.55 8 17C8 16.45 7.55 16 7 16Z" />
    <path d="M14 2H13C12.45 2 12 2.45 12 3C12 3.55 12.45 4 13 4H14C15.1 4 16 4.9 16 6V7C16 7.55 16.45 8 17 8C17.55 8 18 7.55 18 7V6C18 3.79 16.21 2 14 2Z" />
    <path d="M13.44 12.02C13.8 11.43 14 10.73 14 10C14 7.79 12.21 6 10 6C7.79 6 6 7.79 6 10C6 12.21 7.79 14 10 14C10.73 14 11.43 13.8 12.02 13.44L15.29 16.71C15.49 16.9 15.74 17 16 17C16.26 17 16.51 16.9 16.71 16.71C17.1 16.32 17.1 15.68 16.71 15.29L13.44 12.02V12.02ZM11.7 11.05C11.54 11.31 11.31 11.54 11.05 11.7C10.74 11.89 10.38 12 10 12C8.9 12 8 11.1 8 10C8 8.9 8.9 8 10 8C11.1 8 12 8.9 12 10C12 10.38 11.89 10.74 11.7 11.05V11.05Z" />
  </svg>
);

export const VPRIcon: FC<Styled> = ({ className }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="CurrentColor"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M15 2H9C7.35 2 6 3.35 6 5V6H5C3.35 6 2 7.35 2 9V15C2 16.65 3.35 18 5 18H11C12.65 18 14 16.65 14 15H12C12 15.55 11.55 16 11 16H5C4.45 16 4 15.55 4 15V9C4 8.45 4.45 8 5 8H6V11C6 12.65 7.35 14 9 14H15C16.65 14 18 12.65 18 11V5C18 3.35 16.65 2 15 2ZM9 12C8.45 12 8 11.55 8 11V8H11C11.55 8 12 8.45 12 9V12H9ZM16 11C16 11.55 15.55 12 15 12H14V9C14 7.35 12.65 6 11 6H8V5C8 4.45 8.45 4 9 4H15C15.55 4 16 4.45 16 5V11Z" />
  </svg>
);

export const VPSIcon: FC<Styled> = ({ className }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="CurrentColor"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M3,8c.5,0,1-.5,1-1v-1c0-1.1.9-2,2-2h1c.5,0,1-.5,1-1s-.5-1-1-1h-1c-2.2,0-4,1.8-4,4v1c0,.5.5,1,1,1Z" />
    <path d="M7,16h-1c-1.1,0-2-.9-2-2v-1c0-.5-.5-1-1-1s-1,.5-1,1v1c0,2.2,1.8,4,4,4h1c.5,0,1-.5,1-1s-.5-1-1-1Z" />
    <path d="M14,2h-1c-.5,0-1,.5-1,1s.5,1,1,1h1c1.1,0,2,.9,2,2v1c0,.5.5,1,1,1s1-.5,1-1v-1c0-2.2-1.8-4-4-4Z" />
    <path d="M17,12c-.5,0-1,.5-1,1v1c0,1.1-.9,2-2,2h-1c-.5,0-1,.5-1,1s.5,1,1,1h1c2.2,0,4-1.8,4-4v-1c0-.5-.5-1-1-1Z" />
    <path d="M14,10c0-2.2-1.8-4-4-4s-4,1.8-4,4,1.8,4,4,4,4-1.8,4-4ZM10,12c-1.1,0-2-.9-2-2s.9-2,2-2,2,.9,2,2-.9,2-2,2Z" />
  </svg>
);

export const VPCIcon: FC<Styled> = ({ className }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="CurrentColor"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M17 2H9C8.45 2 8 2.45 8 3C8 3.55 8.45 4 9 4H16V11C16 11.55 16.45 12 17 12C17.55 12 18 11.55 18 11V3C18 2.45 17.55 2 17 2Z" />
    <path d="M11 16H4V9C4 8.45 3.55 8 3 8C2.45 8 2 8.45 2 9V17C2 17.55 2.45 18 3 18H11C11.55 18 12 17.55 12 17C12 16.45 11.55 16 11 16Z" />
    <path d="M12.5 9H11V7.5C11 6.95 10.55 6.5 10 6.5C9.45 6.5 9 6.95 9 7.5V9H7.5C6.95 9 6.5 9.45 6.5 10C6.5 10.55 6.95 11 7.5 11H9V12.5C9 13.05 9.45 13.5 10 13.5C10.55 13.5 11 13.05 11 12.5V11H12.5C13.05 11 13.5 10.55 13.5 10C13.5 9.45 13.05 9 12.5 9Z" />
  </svg>
);

export const VPDIcon: FC<Styled> = ({ className }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="CurrentColor"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M8 5H17C17.55 5 18 4.55 18 4C18 3.45 17.55 3 17 3H8C7.45 3 7 3.45 7 4C7 4.55 7.45 5 8 5Z" />
    <path d="M17 7H8C7.45 7 7 7.45 7 8C7 8.55 7.45 9 8 9H17C17.55 9 18 8.55 18 8C18 7.45 17.55 7 17 7Z" />
    <path d="M17 11H14C13.45 11 13 11.45 13 12C13 12.55 13.45 13 14 13H17C17.55 13 18 12.55 18 12C18 11.45 17.55 11 17 11Z" />
    <path d="M11 12C11 11.45 10.55 11 10 11H3C2.45 11 2 11.45 2 12C2 12.55 2.45 13 3 13H10C10.55 13 11 12.55 11 12Z" />
    <path d="M17 15H8C7.45 15 7 15.45 7 16C7 16.55 7.45 17 8 17H17C17.55 17 18 16.55 18 16C18 15.45 17.55 15 17 15Z" />
  </svg>
);

export const AlertIcon: FC<Styled> = ({ className }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM9 12C9 12.5523 8.55229 13 8 13C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11C8.55229 11 9 11.4477 9 12ZM8 3C7.44772 3 7 3.44772 7 4V8C7 8.55228 7.44772 9 8 9C8.55229 9 9 8.55228 9 8V4C9 3.44772 8.55229 3 8 3Z"
      fill="#EAB308"
    />
  </svg>
);

export const FeedCheckIcon: FC<Styled> = ({ className }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 23.2001C18.1856 23.2001 23.2001 18.1856 23.2001 12C23.2001 5.81446 18.1856 0.800049 12 0.800049C5.81446 0.800049 0.800049 5.81446 0.800049 12C0.800049 18.1856 5.81446 23.2001 12 23.2001ZM17.19 10.19C17.7367 9.64326 17.7367 8.75683 17.19 8.2101C16.6433 7.66337 15.7568 7.66337 15.2101 8.2101L10.6 12.8201L8.79 11.0101C8.24327 10.4634 7.35683 10.4634 6.8101 11.0101C6.26337 11.5568 6.26337 12.4433 6.8101 12.99L9.6101 15.79C10.1568 16.3367 11.0433 16.3367 11.59 15.79L17.19 10.19Z"
      fill="#22C55E"
    />
  </svg>
);

export const FeedWarningIcon: FC<Styled> = ({ className }) => (
  <svg
    width="22"
    height="21"
    viewBox="0 0 22 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.55976 2.3384C9.63021 0.435377 12.3701 0.435376 13.4406 2.3384L21.253 16.2272C22.3029 18.0937 20.9541 20.3999 18.8126 20.3999H3.18774C1.04623 20.3999 -0.30257 18.0937 0.747332 16.2272L8.55976 2.3384ZM12.4001 16.2C12.4001 16.9732 11.7732 17.6 11 17.6C10.2269 17.6 9.60005 16.9732 9.60005 16.2C9.60005 15.4269 10.2269 14.8 11 14.8C11.7732 14.8 12.4001 15.4269 12.4001 16.2ZM11 5.00005C10.2269 5.00005 9.60005 5.62685 9.60005 6.40005V10.6C9.60005 11.3732 10.2269 12 11 12C11.7732 12 12.4 11.3732 12.4 10.6V6.40005C12.4 5.62685 11.7732 5.00005 11 5.00005Z"
      fill="#FACC15"
    />
  </svg>
);

//I would rather create ticket co check if this icon disappear accidentally
export const FeedErrorIcon: FC<Styled> = ({ className }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.2001 12C23.2001 18.1856 18.1856 23.2001 12 23.2001C5.81446 23.2001 0.800049 18.1856 0.800049 12C0.800049 5.81446 5.81446 0.800049 12 0.800049C18.1856 0.800049 23.2001 5.81446 23.2001 12ZM13.4001 17.6C13.4001 18.3732 12.7732 19 12 19C11.2269 19 10.6 18.3732 10.6 17.6C10.6 16.8269 11.2269 16.2001 12 16.2001C12.7732 16.2001 13.4001 16.8269 13.4001 17.6ZM12 5.00005C11.2269 5.00005 10.6 5.62685 10.6 6.40005V12C10.6 12.7732 11.2269 13.4 12 13.4C12.7732 13.4 13.4 12.7732 13.4 12V6.40005C13.4 5.62685 12.7732 5.00005 12 5.00005Z"
      fill="#EF4444"
    />
  </svg>
);

export const ExtendedViewIcon: FC<Styled> = ({ className }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="CurrentColor"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect x="3" y="3" width="18" height="7" rx="2" />
    <rect x="3" y="14" width="18" height="7" rx="2" />
  </svg>
);

export const LoaderIcon: FC<Styled> = ({ className = "" }) => (
  <svg
    className={`h-6 w-6 text-stone-700 dark:text-stone-300 ${className}`}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    role="img"
    aria-label="spinning loader"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    ></circle>
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    ></path>
  </svg>
);

export const ProductCheckIcon: FC<Styled> = ({ className }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7 10L9 12L13 8M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z"
      stroke="#111827"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DraggableIcon: FC<Styled> = ({ className }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="CurrentColor"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M9 20C8.45 20 7.97917 19.8042 7.5875 19.4125C7.19583 19.0208 7 18.55 7 18C7 17.45 7.19583 16.9792 7.5875 16.5875C7.97917 16.1958 8.45 16 9 16C9.55 16 10.0208 16.1958 10.4125 16.5875C10.8042 16.9792 11 17.45 11 18C11 18.55 10.8042 19.0208 10.4125 19.4125C10.0208 19.8042 9.55 20 9 20ZM15 20C14.45 20 13.9792 19.8042 13.5875 19.4125C13.1958 19.0208 13 18.55 13 18C13 17.45 13.1958 16.9792 13.5875 16.5875C13.9792 16.1958 14.45 16 15 16C15.55 16 16.0208 16.1958 16.4125 16.5875C16.8042 16.9792 17 17.45 17 18C17 18.55 16.8042 19.0208 16.4125 19.4125C16.0208 19.8042 15.55 20 15 20ZM9 14C8.45 14 7.97917 13.8042 7.5875 13.4125C7.19583 13.0208 7 12.55 7 12C7 11.45 7.19583 10.9792 7.5875 10.5875C7.97917 10.1958 8.45 10 9 10C9.55 10 10.0208 10.1958 10.4125 10.5875C10.8042 10.9792 11 11.45 11 12C11 12.55 10.8042 13.0208 10.4125 13.4125C10.0208 13.8042 9.55 14 9 14ZM15 14C14.45 14 13.9792 13.8042 13.5875 13.4125C13.1958 13.0208 13 12.55 13 12C13 11.45 13.1958 10.9792 13.5875 10.5875C13.9792 10.1958 14.45 10 15 10C15.55 10 16.0208 10.1958 16.4125 10.5875C16.8042 10.9792 17 11.45 17 12C17 12.55 16.8042 13.0208 16.4125 13.4125C16.0208 13.8042 15.55 14 15 14ZM9 8C8.45 8 7.97917 7.80417 7.5875 7.4125C7.19583 7.02083 7 6.55 7 6C7 5.45 7.19583 4.97917 7.5875 4.5875C7.97917 4.19583 8.45 4 9 4C9.55 4 10.0208 4.19583 10.4125 4.5875C10.8042 4.97917 11 5.45 11 6C11 6.55 10.8042 7.02083 10.4125 7.4125C10.0208 7.80417 9.55 8 9 8ZM15 8C14.45 8 13.9792 7.80417 13.5875 7.4125C13.1958 7.02083 13 6.55 13 6C13 5.45 13.1958 4.97917 13.5875 4.5875C13.9792 4.19583 14.45 4 15 4C15.55 4 16.0208 4.19583 16.4125 4.5875C16.8042 4.97917 17 5.45 17 6C17 6.55 16.8042 7.02083 16.4125 7.4125C16.0208 7.80417 15.55 8 15 8Z"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </svg>
);
